import { render } from "./VideoScriptAppFinalReview.vue?vue&type=template&id=2a0e543c&lang=true"
import script from "./VideoScriptAppFinalReview.vue?vue&type=script&lang=js"
export * from "./VideoScriptAppFinalReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__